// Angular
import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, CanActivateChild, Router, RouterStateSnapshot, UrlTree} from '@angular/router';
// RxJS
import {Observable} from 'rxjs';
import {tap} from 'rxjs/operators';
// NGRX
import {select, Store} from '@ngrx/store';
// Auth reducers and selectors
import {AppState} from '../../../core/reducers/';
import {isLoggedIn} from '../_selectors/auth.selectors';
import {AuthService} from '../_services';

@Injectable()
export class AuthGuard implements CanActivate, CanActivateChild {
	constructor(private store: Store<AppState>, private router: Router, private authService: AuthService) {
	}

	canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
		return this.store
			.pipe(
				select(isLoggedIn),
				tap(loggedIn => {
					let tokenExpired = this.authService.isTokenExpired(); // TODO: Implementar token refresh
					if (tokenExpired || !loggedIn) {
						this.router.navigateByUrl('/auth/login');
					}
				})
			);
	}

	canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot)
		: Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
		return this.store
			.pipe(
				select(isLoggedIn),
				tap(loggedIn => {
					let tokenExpired = this.authService.isTokenExpired(); // TODO: Implementar token refresh
					if (tokenExpired || !loggedIn) {
						this.router.navigateByUrl('/auth/login');
					}
				})
			);
	}
}
